import { Pipe, PipeTransform } from "@angular/core";
import { Linkifier } from "src/app/models/linkifier";
import { LinkifyModule } from "./linkify.module";

@Pipe({
    name: "linkify",
})
export class LinkifyPipe implements PipeTransform {
    constructor(private linkifier: Linkifier) {}

    transform(value: string): string {
        return this.linkifier.link(value);
    }
}